<template>
  <div class="grey-background section">
    <div class="container">
      <div class="row items-center">
        <div class="col-12 col-md-6" :class="{ 'justify-center text-center': $q.screen.lt.md }">
          <h3 class="text-subtitle1 text-weight-medium text-grey-7 q-mb-xs">
            {{ $t('home.how_to_section.subtitle') }}
          </h3>
          <h4 class="text-h4 text-weight-bold text-primary q-mb-md two-lines">
            {{ $t('home.how_to_section.title') }}
          </h4>
          <q-btn
            class="btn-yellow"
            :label="$t('home.how_to_section.btn_label')"
            :to="{ name: 'How To Apply' }"
            rounded
            no-caps
          />
        </div>

        <div class="col-12 col-md-6 image-container">
          <img
            src="~assets/home/how-to-image.jpg"
            alt="Students collaborating"
            class="my-hero-image"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.my-card {
  max-width: 1200px;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
}

.image-container {
  position: relative;
  overflow: hidden;
  padding: 40px 0;
}

.my-hero-image {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 20px;
  border-bottom: 8px solid $secondary;
}

.two-lines {
  @media (min-width: 1024px) {
    width: 350px;
    white-space: normal;
  }
}
</style>
